import { gql, useMutation } from '@apollo/client';
import { useGeneralSoContext } from 'src/common/context';

const FINISH_OFFLINE_PURCHASE = gql`
  mutation FinishOfflinePurchase($offerId: String!) {
    finishOfflinePurchase(offerId: $offerId)
  }
`;

export function useFinishOfflinePurchase() {
  const { soId, offerId } = useGeneralSoContext();
  const [mutation] = useMutation<{ finishOfflinePurchase: boolean }>(FINISH_OFFLINE_PURCHASE);

  const finishOfflinePurchase = () =>
    mutation({
      variables: { soId: soId!, offerId: offerId! }
    });

  return [finishOfflinePurchase] as const;
}
